// 学生端页面
import studentIndex from "../pages/student/index.vue" // 学生端首页
import myClass from "../pages/student/myClass.vue" // 学生端我的班级
import joinRecord from "../pages/student/joinRecord.vue" // 学生端加入班级记录
import grade from "../pages/student/grade.vue" // 学生端成绩页面
import eventLayout from '../pages/student/EventLayout.vue'; // 学生实践公共入口页面
import stepOne from '../pages/student/experiment/stepOne.vue'; // 学生实践-环节一
import stepTwo from '../pages/student/experiment/stepTwo.vue'; // 环节二
import stepThree from '../pages/student/experiment/stepThree.vue'; // 环节三
import unitOne from '../pages/student/experiment/stepFour/unitOne.vue'; // 环节四-第一题
import unitTwo from '../pages/student/experiment/stepFour/unitTwo.vue'; // 环节四-第二题
import unitSix from '../pages/student/experiment/stepFour/unitSix.vue'; // 环节四-第二题 - 浙江金融定制 T009
import unitThree from '../pages/student/experiment/stepFour/unitThree.vue'; // 环节四-第三题
import unitFour from '../pages/student/experiment/stepFour/unitFour.vue'; // 环节四-第四题
import unitFive from '../pages/student/experiment/stepFour/unitFive.vue'; // 环节四-第四题 - 浙江金融定制 T008
import joinClass from "../pages/student/joinClass.vue" // 加入班级页面

// studentRoutes 和 studentMap 需要同步维护 否则会出现路由跳转错误
export const studentRoutes = [
  {
    path: "/:schoolcode(\\d+)?/",
    name: "首页",
    // component: studentIndex,
    redirect: "/:schoolcode(\\d+)?/student"
  },
  {
    path: "/:schoolcode(\\d+)?/student",
    name: "学生端",
    component: studentIndex,
  },
  {
    path: "/:schoolcode(\\d+)?/student/myClass",
    name: "我的班级",
    component: myClass,
  },
  {
    path: "/:schoolcode(\\d+)?/student/grade",
    name: "查看成绩",
    component: grade,
  },
  {
    path: "/:schoolcode(\\d+)?/student/joinrecord",
    name: "加入班级记录",
    component: joinRecord,
  },
  {
    path: "/:schoolcode(\\d+)?/student/joinclass",
    name: "扫码加入班级",
    component: joinClass,
  },
  // 学生端-实践
  {
    path: "/:schoolcode(\\d+)?/student/experiment",
    name: "实践活动",
    component: eventLayout,
    redirect: "/:schoolcode(\\d+)?/student/experiment/stepone",
    children: [
      // code/code2 字段：用于点击环节、任务和后端返回数据作对比,查出页面path,做路由跳转
      { path: "stepone", name: "环节一：品思政之味", component: stepOne, code: "T001", code2: "P001", },
      { path: "steptwo", name: "环节二：悟思政之韵", component: stepTwo, code: "T002", code2: "P002", },
      { path: "stepthree", name: "环节三：践思政之道", component: stepThree, code: "T003", code2: "P003", },
      { path: "unitone", name: "环节四：结思政之果-思政小测", component: unitOne, code: "T004", code2: "P004", },
      { path: "unittwo", name: "环节四：结思政之果-云馆图谱", component: unitTwo, code: "T005", code2: "P004", },
      { path: "unitthree", name: "环节四：结思政之果-点位打卡", component: unitThree, code: "T006", code2: "P004" },
      { path: "unitfour", name: "环节四：结思政之果-实践微影", component: unitFour, code: "T007", code2: "P004" },
      { path: "unitfive", name: "环节四：结思政之果-实践报告", component: unitFive, code: "T008", code2: "P004" },
      { path: "unitsix", name: "环节四：结思政之果-展馆故事", component: unitSix, code: "T009", code2: "P004" },
    ]
  }
]
// studentRoutes 和 studentMap 需要同步维护 否则会出现路由跳转错误
export const studentMap = [
  '/student', '/student/joinclass', '/student/myClass', '/student/grade', '/student/joinrecord', '/student/experiment', 
  '/student/experiment/stepone', 
  '/student/experiment/steptwo',
  '/student/experiment/stepthree', 
  '/student/experiment/unitone', 
  '/student/experiment/unittwo', 
  '/student/experiment/unitthree', 
  '/student/experiment/unitfour', 
  '/student/experiment/unitfive',
  '/student/experiment/unitsix',
]
